import { render, staticRenderFns } from "./invadobay-search-preview.vue?vue&type=template&id=5089be14&scoped=true"
import script from "./invadobay-search-preview.vue?vue&type=script&lang=js"
export * from "./invadobay-search-preview.vue?vue&type=script&lang=js"
import style0 from "./invadobay-search-preview.vue?vue&type=style&index=0&id=5089be14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5089be14",
  null
  
)

export default component.exports